import dc from "../assets/images/comedy.png";
import horror from "../assets/images/horror.png";
import action from "../assets/images/actionf.png";
import netflix from "../assets/images/netflixone.png";
import focus from "../assets/images/pixer.png";
import { Link } from "react-router-dom";

const Genre = () => {
  return (
    <div className="bg-gray-900 sm:h-[45vh]">
      <div className=" pt-6">
        <h1 className="text-gray-400 text-xl sm:text-2xl font-bold tracking-wider text-center py-3">
          Start watching
        </h1>
      </div>

      <div className="px-3 cursor-pointer sm:sm:w-[90%]  sm:ml-auto space-y-5 sm:space-y-0  sm:mr-auto sm:flex sm:justify-between sm:items-center mt-5">
        <Link to="/comedy">
          <div className="px-3 py-3 transition duration-200 ease-in transform sm:hover:scale-105 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
            <img className="h-32 object-contain bg-gray-300" src={dc} alt="" />
          </div>
        </Link>

        <Link to="/horror">
          <div className="px-3 py-3 transition duration-200 ease-in transform sm:hover:scale-105 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
            <img className="h-32 object-contain" src={horror} alt="" />
          </div>
        </Link>

        <Link to="/action">
          <div className="px-3 py-3 bg-gray-800 shadow-lg border border-gray-700 rounded-sm transition duration-200 ease-in transform sm:hover:scale-105 hover:bg-gray-700 hover:border-gray-400 flex justify-center">
            <img className="h-32 object-contain" src={action} alt="" />
          </div>
        </Link>

        <Link to="/animation">
          <div className="px-3 py-3 bg-gray-800 shadow-lg border transition duration-200 ease-in transform sm:hover:scale-105 border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
            <img className="h-32 object-contain" src={focus} alt="" />
          </div>
        </Link>

        <Link to="/netflix">
          <div className="px-3 py-3 bg-gray-800 shadow-lg  transition duration-200 ease-in transform sm:hover:scale-105 border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
            <img className="h-32 object-contain" src={netflix} alt="" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Genre;
